module.exports = __webpack_public_path__ + "static/media/design-icon.cce2c689.svg";